import Cropper from "react-cropper";

function ReactCropper(props) {
  return <Cropper {...props}>{props.children}</Cropper>;
}

module.exports = ReactCropper;
